// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tableSimple":"_1yh7wT","heading":"_1Ef6AT","table":"_3p8oOA","tr":"_3sMT8M","td":"_7T3itc","th":"_21jkVJ","thead":"_3_U1ta"};